var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NewsItem = exports.NewsTitle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/News/TopNews.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var NewsTitle = function NewsTitle(_ref) {
  var headline = _ref.headline,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["headline"]);
  return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    p: 2
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.SubHeading, {
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, headline));
};

exports.NewsTitle = NewsTitle;

var NewsItem = function NewsItem(_ref2) {
  var headline = _ref2.headline,
      category = _ref2.category,
      publishedAt = _ref2.publishedAt,
      imageUrl = _ref2.imageUrl,
      onPress = _ref2.onPress,
      _ref2$big = _ref2.big,
      big = _ref2$big === void 0 ? false : _ref2$big,
      renderImage = _ref2.renderImage,
      href = _ref2.href;
  return _react.default.createElement(_Touchable.default, {
    onPress: onPress,
    href: href,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Column, {
    mb: 2,
    borderX: 1,
    borderY: 1,
    borderColor: "border.main",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }, big ? _react.default.createElement(_react.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 17
    }
  }, _react.default.createElement(NewsTitle, (0, _extends2.default)({
    headline: headline
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 21
    }
  })), renderImage ? renderImage(imageUrl, 18, 10) : _react.default.createElement(_Logos.TeaserImage, {
    width: "100%",
    aspectRatio: 18 / 10,
    src: imageUrl,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 25
    }
  })) : _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 17
    }
  }, renderImage ? renderImage(imageUrl, 18, 10, 97) : _react.default.createElement(_Logos.TeaserImage, {
    width: 97,
    aspectRatio: 18 / 10,
    src: imageUrl,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 25
    }
  }), _react.default.createElement(NewsTitle, (0, _extends2.default)({
    flexing: true,
    alignItems: "center"
  }, {
    headline: headline
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 21
    }
  })))));
};

exports.NewsItem = NewsItem;

var TopNews = function TopNews(_ref3) {
  var _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      onItemPress = _ref3.onItemPress,
      renderImage = _ref3.renderImage,
      createHref = _ref3.createHref;
  return items.length ? _react.default.createElement(_react.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  }, items.map(function (item, index) {
    return _react.default.createElement(NewsItem, (0, _extends2.default)({
      key: "topNews_" + (0, _get.default)(item, 'id'),
      renderImage: renderImage,
      onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onItemPress, item),
      href: (0, _PropsHelper.executeFunctionOrUndefined)(createHref, item)
    }, _objectSpread(_objectSpread({}, item), {}, {
      big: index === 0
    }), {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 17
      }
    }));
  })) : null;
};

var _default = TopNews;
exports.default = _default;